import { render } from "./AudioTranscoder.vue?vue&type=template&id=40a4870e&scoped=true"
import script from "./AudioTranscoder.vue?vue&type=script&lang=js"
export * from "./AudioTranscoder.vue?vue&type=script&lang=js"

import "./AudioTranscoder.vue?vue&type=style&index=0&id=40a4870e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a4870e"]])

export default __exports__